module.exports = __webpack_public_path__ + "assets/img/financing.cdd0a7db.jpg";